import { NOT_PLURALIZE, PLURALIZE } from '../constants';

// eslint-disable-next-line consistent-return
const usePluralize = (number, housing, buyOrRent) => {
  if (buyOrRent !== null) {
    if (housing === 'wohnung' && number <= 1 && buyOrRent === 'mieten') {
      return {
        housing: 'Wohnung',
        buyOrRent: 'zur Miete',
      };
    }
    if (housing === 'wohnung' && number >= 1 && buyOrRent === 'mieten') {
      return {
        housing: 'Wohnungen',
        buyOrRent: 'zur Miete',
      };
    }
    if (housing === 'wohnung' && number <= 1 && buyOrRent === 'kaufen') {
      return {
        housing: 'Wohnung',
        buyOrRent: 'zu Kaufen',
      };
    }
    if (housing === 'wohnung' && number >= 1 && buyOrRent === 'kaufen') {
      return {
        housing: 'Wohnungen',
        buyOrRent: 'zu Kaufen',
      };
    }
    if (housing === 'haus' && number <= 1 && buyOrRent === 'mieten') {
      return {
        housing: 'Haus',
        buyOrRent: 'zur Miete',
      };
    }
    if (housing === 'haus' && number >= 1 && buyOrRent === 'mieten') {
      return {
        housing: 'Häuser',
        buyOrRent: 'zur Miete',
      };
    }
    if (housing === 'haus' && number <= 1 && buyOrRent === 'kaufen') {
      return {
        housing: 'Haus',
        buyOrRent: 'zu Kaufen',
      };
    }
    if (housing === 'haus' && number >= 1 && buyOrRent === 'kaufen') {
      return {
        housing: 'Häuser',
        buyOrRent: 'zu Kaufen',
      };
    }
  } else {
    if (number <= 1) {
      return {
        housing: NOT_PLURALIZE[housing],
      };
    }
    if (number >= 1) {
      return {
        housing: PLURALIZE[housing],
      };
    }
  }
};
export default usePluralize;
